import React, { FC, PropsWithChildren } from 'react';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './StatusTag.translations.json';
import { Tag } from 'antd';
import styled from 'styled-components';
import {
  colorDraftBg,
  colorDraftBorder,
  colorInactiveBg,
  colorInactiveBorder,
  colorSuccessBg,
  colorSuccessBorder,
} from '@atlas-frontend/design-tokens';

const { addTranslations, useTranslation } = i18nNsFactory('status-tag');
addTranslations(translations);

export interface StatusProps {
  status: string;
}

export const StatusTag: FC<PropsWithChildren<StatusProps>> = (props) => {
  const { status } = props;
  const { t } = useTranslation();

  return (
    <UppercaseTag className={status}>{t(`status.${status}`)}</UppercaseTag>
  );
};

const UppercaseTag = styled(Tag)`
  margin: 0;
  text-transform: uppercase;

  &:is(.DRAFT) {
    border-color: ${colorDraftBorder};
    background-color: ${colorDraftBg};
  }
  &:is(.ACTIVE) {
    border-color: ${colorSuccessBorder};
    background-color: ${colorSuccessBg};
  }
  &:is(.INACTIVE) {
    border-color: ${colorInactiveBorder};
    background-color: ${colorInactiveBg};
  }
`;
